import { Card } from 'antd';

import classnames from 'classnames';

import styles from './styles.module.scss';

import img2 from '../../../assets/images/diagri-background.png';

const sidebarBackground = {
  backgroundImage: 'url(' + img2 + ')',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center'
};

function Container({ children }) {
  return (
    <div
      className={classnames(styles['privacy-terms-section'], 'auth-wrapper align-items-center d-flex')}
      style={sidebarBackground}>
      <div className="container overflow-hidden">
        <Card className={styles.card}>{children}</Card>
      </div>
    </div>
  );
}
export default Container;
